function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Toolbar as ToolbarMUI, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { LocaleContext } from '@tecsinapse/ui-kit';
import { verifyIfString } from '@tecsinapse/es-utils/build/object';
import SelectionActions from './SelectionActions/SelectionActions';
import AdvancedFilters from '../AdvancedFilters/AdvancedFilters';
import { toolbarOptionsTypes } from '../utils/propTypes';
import Exporter from '../Exporter/Exporter';
import SelectedFilters from './SelectedFilters/SelectedFilters';
var tableToolbarStyles = makeStyles(function (theme) {
  return {
    toolbar: {
      margin: theme.spacing(1 / 2, 1 / 2, 0, 1 / 2),
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      minHeight: '48px',
      justifyContent: 'space-between'
    },
    title: {
      width: '100%'
    },
    filter: {
      display: 'flex',
      flexDirection: 'row'
    }
  };
});

var SimpleToolbar = function SimpleToolbar(_ref) {
  var options = _ref.options,
      _ref$exportOptions = _ref.exportOptions,
      exportOptions = _ref$exportOptions === void 0 ? {} : _ref$exportOptions,
      data = _ref.data,
      columns = _ref.columns,
      filters = _ref.filters,
      setFilters = _ref.setFilters,
      setLoading = _ref.setLoading,
      rowCount = _ref.rowCount,
      mobile = _ref.mobile,
      customAdvancedFilters = _ref.customAdvancedFilters,
      onDrawerClose = _ref.onDrawerClose;

  var _ref2 = options || {},
      title = _ref2.title,
      advancedFilters = _ref2.advancedFilters;

  var classes = tableToolbarStyles();

  var _useContext = useContext(LocaleContext),
      tooltipAdvancedFilter = _useContext.Table.tooltipAdvancedFilter;

  var _ref3 = exportOptions || {},
      exportTypes = _ref3.exportTypes;

  if (!advancedFilters && !title && (!exportTypes || exportTypes.length === 0 || !(exportTypes === null || exportTypes === void 0 ? void 0 : exportTypes.position))) {
    return null;
  }

  var isTitleString = verifyIfString(title);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ToolbarMUI, {
    className: classes.toolbar
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, isTitleString ? /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    id: "tableTitle"
  }, title) : title), /*#__PURE__*/React.createElement("div", {
    className: classes.filter
  }, (exportOptions === null || exportOptions === void 0 ? void 0 : exportOptions.position) !== 'footer' && /*#__PURE__*/React.createElement(Exporter, _extends({}, exportOptions, {
    data: data,
    columns: columns,
    filters: filters,
    setLoading: setLoading,
    rowCount: rowCount
  })), /*#__PURE__*/React.createElement(AdvancedFilters, {
    tooltipAdvancedFilter: tooltipAdvancedFilter,
    advancedFilters: advancedFilters,
    setFilters: setFilters,
    filters: filters,
    mobile: mobile,
    customAdvancedFilters: customAdvancedFilters,
    onDrawerClose: onDrawerClose
  }))), advancedFilters && /*#__PURE__*/React.createElement(SelectedFilters, {
    advancedFilters: advancedFilters,
    filters: filters,
    setFilters: setFilters
  }));
};

var Toolbar = function Toolbar(_ref4) {
  var options = _ref4.options,
      selectedRows = _ref4.selectedRows,
      selection = _ref4.selection,
      exportOptions = _ref4.exportOptions,
      data = _ref4.data,
      columns = _ref4.columns,
      filters = _ref4.filters,
      setFilters = _ref4.setFilters,
      setLoading = _ref4.setLoading,
      rowCount = _ref4.rowCount,
      _ref4$tableToolbarHid = _ref4.tableToolbarHide,
      tableToolbarHide = _ref4$tableToolbarHid === void 0 ? false : _ref4$tableToolbarHid,
      _ref4$mobile = _ref4.mobile,
      mobile = _ref4$mobile === void 0 ? false : _ref4$mobile,
      customAdvancedFilters = _ref4.customAdvancedFilters,
      onDrawerClose = _ref4.onDrawerClose;

  if (tableToolbarHide) {
    return null;
  }

  if (!options && !selection && !exportOptions) {
    return null;
  }

  if (selectedRows.length === 0) {
    return /*#__PURE__*/React.createElement(SimpleToolbar, {
      options: options,
      exportOptions: exportOptions,
      data: data,
      filters: filters,
      setFilters: setFilters,
      columns: columns,
      setLoading: setLoading,
      rowCount: rowCount,
      mobile: mobile,
      customAdvancedFilters: customAdvancedFilters,
      onDrawerClose: onDrawerClose
    });
  }

  return /*#__PURE__*/React.createElement(SelectionActions, {
    options: options,
    selectedRows: selectedRows
  });
};

Toolbar.defaultProps = {
  selectedRows: [],
  selection: false,
  tableToolbarHide: false,
  options: null
};
Toolbar.propTypes = {
  selectedRows: PropTypes.arrayOf(PropTypes.object),
  selection: PropTypes.bool,
  tableToolbarHide: PropTypes.bool,
  options: toolbarOptionsTypes
};
export default Toolbar;